import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import Link from "next/link";
import { useTranslation } from "next-i18next";

const ResourcesCenter = () => {
    const { t } = useTranslation("common");
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1,
            partialVisibilityGutter: 40 // For partial visibility effect
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1.5,
            partialVisibilityGutter: 40 // For partial visibility effect
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            partialVisibilityGutter: 0
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 0
        }
    };

    return (
        <div className="mw-carousel sm-testimonial resources-carousel">
            <div className="container">
                <Carousel
                    responsive={responsive}
                    infinite={true}
                    autoPlay={false}
                    autoPlaySpeed={5000}
                    partialVisible={true}
                    itemClass="carousel-item-padding-40-px"
                >
                    <div className="w-full flex justify-center">
                        <div className="mw-testimonial">
                            <div className="img">
                                <img src="/images/case-study/mindorigin-mw.svg" alt="Mindorigin" width={100} height={100} />
                            </div>
                            <h4>How Middleware Helped MindOrigin Cut Observability Costs by 75%</h4>
                            <div className="d-flex">
                                <p>Case Study</p>
                                <Link href="/customers/mindorigin/" className="read-more">{t('blog.cta.readMore')}</Link>
                            </div>
                        </div>
                    </div>

                    <div className="w-full flex justify-center">
                        <div className="mw-testimonial">
                            <div className="img">
                                <img src="https://middleware.io/backend/wp-content/uploads/2024/04/Full-stack-observability-whitepaper1.jpg" alt="Whitepaper" width={100} height={100} />
                            </div>
                            <h4>Full-Stack Observability is a Must to Modernize Complex Cloud Environments</h4>
                            <div className="d-flex">
                                <p>Whitepaper</p>
                                <Link href="/whitepaper/full-stack-observability-modernize-complex-cloud-environments/" className="read-more">{t('cta.downloadNow')}</Link>
                            </div>
                        </div>
                    </div>

                    <div className="w-full flex justify-center">
                        <div className="mw-testimonial">
                            <div className="img">
                                <img src="https://middleware.io/backend/wp-content/uploads/2025/02/Observability-trends-2025.jpg" alt="Product Updates" width={100} height={100} />
                            </div>
                            <h4>Top 10 Observability Trends for 2025</h4>
                            <div className="d-flex">
                                <p>Knowledge</p>
                                <Link href="/blog/observability/trends/" className="read-more">{t('blog.cta.readMore')}</Link>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </div>
    );
}

export default ResourcesCenter;
